import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ProductDetailsService {
  private apiUrl = environment.apiUrl + '/api/notify';

  constructor(private http: HttpClient) {}

  sendNotification(
    channel: 'email' | 'whatsapp',
    to: string,
    message: string,
    subject?: string
  ): Observable<string> {
    const params: any = { channel, to, message };
    if (subject) {
      params.subject = subject;
    }
    return this.http.post(this.apiUrl, null, { params, responseType: 'text' });
  }
}
